// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of AuthorityDepartmentUser
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## AuthorityDepartmentUser Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.AuthorityDepartmentUser.GetAll(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuthorityDepartmentUser Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAuthorities = async (option) => {
  const response = await $api.get(
    Endpoints.AuthorityDepartmentUser.GetAuthorities(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## AuthorityDepartmentUser Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(
    Endpoints.AuthorityDepartmentUser.Create(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuthorityDepartmentUser Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const CreateMultiple = async (form) => {
  const response = await $api.post(
    Endpoints.AuthorityDepartmentUser.CreateMultiple(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuthorityDepartmentUser Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(
    Endpoints.AuthorityDepartmentUser.GetById(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuthorityDepartmentUser Update
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.AuthorityDepartmentUser.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuthorityDepartmentUser Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.AuthorityDepartmentUser.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  GetAuthorities,
  Create,
  CreateMultiple,
  GetById,
  Update,
  Delete,
};
